import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class ProductCategory {
  index() {
    return Axios.get(API_URL + 'productcategory-list');
  }

  show(productcategory) {
    return Axios.get(API_URL + `productcategory/${productcategory}`);
  }
}

export default new ProductCategory();



// WEBPACK FOOTER //
// ./src/api/productcategory.js